<template>
  <div>
    <div class="background-top"></div>
    <div class="background-center-top"></div>
    <div class="background-center-bottom"></div>
    <div class="background-bottom"></div>
  </div>
</template>


<style>
.background-top {
  height: 100vh;
  background: url("https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/app_h5/enterprise/answer-top.jpg") no-repeat;
  background-size: 100% 100%;
}
.background-center-top {
  height: 100vh;
  background: url("https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/app_h5/enterprise/answer-center-top.jpg") no-repeat;
  background-size: 100% 100%;
}
.background-center-bottom {
  height: 100vh;
  background: url("https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/app_h5/enterprise/answer-center-bottom.jpg") no-repeat;
  background-size: 100% 100%;
}
.background-bottom {
  height: 80vh;
  background: url("https://supplinkcloud.s3.cn-north-1.jdcloud-oss.com/app_h5/enterprise/answer-bottom.jpg") no-repeat;
  background-size: 100% 100%;
}
</style>

